module.exports = __webpack_public_path__ + "img/certified-empty.be398fe.svg";